export const allFolders = "sl9Ilb";
export const currentMailbox = "HxE3Nb";
export default {allFolders,currentMailbox};